/* eslint-disable no-console */
import Cookies from 'js-cookie'
export const state = () => ({
  isActive: false,
})

export const getters = {
  isActive(state, getters, rootState, rootGetters) {
    if (!rootGetters['quote/allowFreeLockPromotion']) {
      return false
    }

    return state.isActive
  },
}

export const mutations = {
  SET_STATUS: (state, isActive) => {
    state.isActive = isActive
  },
}

export const actions = {
  addPromotion({ commit }) {
    const promotionCookie = Cookies.get('show_promotion')

    if (!promotionCookie) {
      Cookies.set('show_promotion', true, {
        sameSite: 'lax',
        expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
      })
      commit('SET_STATUS', true)
    } else {
      commit('SET_STATUS', Cookies.get('show_promotion'))
    }
  },
  hidePromotion({ commit }) {
    Cookies.set('show_promotion', false, {
      sameSite: 'lax',
      expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
    })
    commit('SET_STATUS', false)
  },
}
